var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ClassifierService, ClassifierView, FilterBuilder, } from '@synisys/idm-classifier-service-client-js';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { ActionBuilder, ContextArg, ContextArgEnum, FieldArg, StateArg, } from '../layout-actions';
import { isNil } from 'lodash';
import { CurrentLanguageProvider } from '@synisys/idm-session-data-provider-api-js';
import { AbstractDestructionSubject } from '../../component/abstract-destruction-subject';
import { takeUntil } from 'rxjs/operators';
import { AsyncDynamicAction, FieldParam } from "@synisys/idm-dynamic-controls-metadata";
var DynamicFormClassifiersService = /** @class */ (function (_super) {
    __extends(DynamicFormClassifiersService, _super);
    function DynamicFormClassifiersService(classifierService, currentLanguageProvider) {
        var _this = _super.call(this) || this;
        _this.classifierService = classifierService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.classifierReplayItems = new Map();
        _this.classifierNameReplayItems = new Map();
        _this.emptyArray = [];
        _this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(takeUntil(_this.destroySubject$))
            .subscribe(function () { return _this.resetCache(); }, console.error);
        return _this;
    }
    DynamicFormClassifiersService.prototype.onClassifierChange = function (event, systemName, classifierKey, entity) {
        var selectedClassifierId = event;
        if (selectedClassifierId && selectedClassifierId >= 0) {
            this.classifierReplayItems
                .get(classifierKey)
                .subscribe(function (classifiers) {
                classifiers.map(function (classifier) {
                    if (classifier.getId() === selectedClassifierId) {
                        entity.getProperty(systemName).value = classifier;
                    }
                });
            }, console.error);
        }
        else {
            entity.getProperty(systemName).value = null;
        }
    };
    DynamicFormClassifiersService.prototype.onSubEntityClassifierChange = function (event, systemName, classifierKey, subEntity) {
        var selectedClassifierId = event;
        if (selectedClassifierId) {
            this.classifierReplayItems
                .get(classifierKey)
                .subscribe(function (classifiers) {
                classifiers.map(function (classifier) {
                    if (classifier.getId() === selectedClassifierId) {
                        subEntity.getProperty(systemName).value = classifier;
                    }
                });
            }, console.error);
        }
    };
    DynamicFormClassifiersService.prototype.resetClassifiers = function (systemNames, entity) {
        systemNames.forEach(function (item) {
            entity.getProperty(item).value = null;
        });
    };
    DynamicFormClassifiersService.prototype.onChildClassifierChange = function (event, systemName, classifierKey, parent, entity) {
        var selectedClassifierId = event;
        if (selectedClassifierId) {
            var itemKey = classifierKey + '_' + parent.getId();
            this.classifierReplayItems
                .get(itemKey)
                .subscribe(function (classifiers) {
                classifiers.map(function (classifier) {
                    if (classifier.getId() === selectedClassifierId) {
                        entity.getProperty(systemName).value = classifier;
                    }
                });
            }, console.error);
        }
        else {
            entity.getProperty(systemName).value = null;
        }
    };
    DynamicFormClassifiersService.prototype.onSubEntityChildClassifierChange = function (event, systemName, classifierKey, parent, subEntity, entity) {
        var selectedClassifierId = event;
        if (selectedClassifierId) {
            var itemKey = classifierKey + '_' + parent.getId();
            this.classifierReplayItems
                .get(itemKey)
                .subscribe(function (classifiers) {
                classifiers.map(function (classifier) {
                    if (classifier.getId() === selectedClassifierId) {
                        subEntity.getProperty(systemName).value = classifier;
                    }
                });
            }, console.error);
        }
        else {
            entity.getProperty(systemName).value = null;
        }
    };
    DynamicFormClassifiersService.prototype.loadClassifiers = function (systemName) {
        if (!this.classifierReplayItems.has(systemName)) {
            var replay_1 = new ReplaySubject(1);
            this.classifierReplayItems.set(systemName, replay_1);
            this.classifierService
                .loadClassifiersView(systemName)
                .subscribe(function (classifiers) {
                replay_1.next(classifiers);
            }, console.error);
        }
        return this.classifierReplayItems.get(systemName);
    };
    DynamicFormClassifiersService.prototype.loadCountryCurrencies = function () {
        var _this = this;
        if (isNil(this.currenciesWithCountry)) {
            this.currenciesWithCountry = new ReplaySubject(1);
            var filterBuilder = new FilterBuilder();
            filterBuilder.not(new FilterBuilder().is('Country', null).build());
            this.classifierService
                .loadClassifiersViewByFilter('Currency', filterBuilder.build().toJson())
                .subscribe(function (classifiers) {
                _this.currenciesWithCountry.next(classifiers);
            }, console.error);
        }
        return this.currenciesWithCountry;
    };
    DynamicFormClassifiersService.prototype.loadClassifiersByParent = function (systemName, parent) {
        if (parent !== null && parent.getId() !== null) {
            var itemKey = systemName + '_' + parent.getId();
            if (!this.classifierReplayItems.has(itemKey)) {
                var replay_2 = new ReplaySubject(1);
                this.classifierReplayItems.set(itemKey, replay_2);
                this.classifierService
                    .loadClassifiersViewByParent(systemName, parent.getId())
                    .subscribe(function (classifiers) {
                    replay_2.next(classifiers);
                }, console.error);
            }
            return this.classifierReplayItems.get(itemKey);
        }
        return Observable.of(this.emptyArray);
    };
    DynamicFormClassifiersService.prototype.onMultiSelectComboItemsChanged = function (selectedIds, systemName, classifierKey, entity) {
        var _this = this;
        var selectedItems;
        selectedItems = entity.getProperty(systemName).value;
        this.classifierReplayItems
            .get(classifierKey)
            .subscribe(function (classifiers) {
            classifiers.map(function (classifier) {
                if (_this.checkIfIdInArray(classifier.getId(), selectedIds)) {
                    selectedItems.push(classifier);
                }
                else {
                    for (var i = 0; i < selectedItems.length; i++) {
                        if (classifier.getId() === selectedItems[i].getId()) {
                            selectedItems.splice(i, 1);
                        }
                    }
                }
            });
        }, console.error);
    };
    DynamicFormClassifiersService.prototype.onMultiSelectItemsChanged = function (selectedItem, systemName, entity, subEntity) {
        var selectedItems;
        if (subEntity) {
            selectedItems = subEntity.getProperty(systemName)
                .value;
        }
        else {
            selectedItems = entity.getProperty(systemName)
                .value;
        }
        var isChecked = selectedItems.find(function (item) { return item.getId() === selectedItem.getId(); }) === undefined;
        if (isChecked) {
            selectedItems.push(selectedItem);
        }
        else {
            for (var i = 0; i < selectedItems.length; i++) {
                if (selectedItem.getId() === selectedItems[i].getId()) {
                    selectedItems.splice(i, 1);
                }
            }
        }
    };
    DynamicFormClassifiersService.prototype.simpleChange = function (mainEntity, systemName, selectedValue) {
        mainEntity.getProperty(systemName).value = selectedValue;
    };
    DynamicFormClassifiersService.prototype.getClassifierName = function (classifier, category) {
        var categoryKey = isNil(category) || isNil(classifier)
            ? ''
            : category + "_" + classifier.getId();
        if (this.classifierNameReplayItems.has(categoryKey)) {
            return this.classifierNameReplayItems.get(categoryKey);
        }
        else {
            var replaySubject_1 = new ReplaySubject(1);
            if (categoryKey === '') {
                this.classifierNameReplayItems.set('', replaySubject_1);
                replaySubject_1.next('');
                return replaySubject_1;
            }
            else if (classifier instanceof ClassifierView) {
                this.classifierNameReplayItems.set(categoryKey, replaySubject_1);
                replaySubject_1.next(classifier.getName());
                return replaySubject_1;
            }
            else {
                this.classifierNameReplayItems.set(categoryKey, replaySubject_1);
                this.classifierService
                    .getEntityName(category, classifier)
                    .subscribe(function (value) { return replaySubject_1.next(value); }, console.error);
                return replaySubject_1;
            }
        }
    };
    DynamicFormClassifiersService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('onChildClassifierChange')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            FieldArg('field'),
            FieldArg('field-category'),
            FieldArg('field-parent'),
            ContextArg(ContextArgEnum.ENTITY),
        ])
            .action(function (event, systemName, classifierKey, parent, entity) {
            return _this.onChildClassifierChange(event, systemName, classifierKey, parent, entity);
        })
            .build());
        result.push(new ActionBuilder()
            .name('onClassifierChange')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            FieldArg('field-name'),
            FieldArg('field-category'),
            ContextArg(ContextArgEnum.CONTEXT_ENTITY),
        ])
            .action(function (event, systemName, classifierKey, entity) {
            return _this.onClassifierChange(event, systemName, classifierKey, entity);
        })
            .build());
        result.push(new ActionBuilder()
            .name('resetClassifiers')
            .params([
            StateArg('systemNames'),
            ContextArg(ContextArgEnum.ENTITY),
        ])
            .action(function (systemNames, entity) {
            return _this.resetClassifiers(systemNames, entity);
        })
            .build());
        // result.push(
        //     new ActionBuilder()
        //         .name('loadClassifiers')
        //         .async(true)
        //         .params([FieldArg('field-category')])
        //         .action((systemName: string) =>
        //                     this.loadClassifiers(systemName)
        //         )
        //         .build()
        // );
        result.push(new ActionBuilder()
            .name('simpleChange')
            .params([
            ContextArg(ContextArgEnum.CONTEXT_ENTITY),
            FieldArg('field-name'),
            ContextArg(ContextArgEnum.EVENT),
        ])
            .action(function (mainEntity, systemName, selectedValue) {
            return _this.simpleChange(mainEntity, systemName, selectedValue);
        })
            .build());
        // result.push(
        //     new ActionBuilder()
        //         .name('loadClassifiersByParent')
        //         // .params([ContextArg(ContextArgEnum.ENTITY), FieldArg('field-name'), ContextArg(ContextArgEnum.EVENT)])
        //         .action((systemName: string, parent: ClassifierView) =>
        //                     this.loadClassifiersByParent(systemName, parent)
        //         )
        //         .build()
        // );
        result.push(new ActionBuilder()
            .name('onMultiSelectItemsChanged')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            FieldArg('field-name'),
            ContextArg(ContextArgEnum.ENTITY),
            ContextArg(ContextArgEnum.ITEM),
        ])
            .action(function (checkedItem, systemName, mainEntity, subEntity) {
            return _this.onMultiSelectItemsChanged(checkedItem, systemName, mainEntity, subEntity);
        })
            .build());
        result.push(new ActionBuilder()
            .name('getClassifierName')
            .params([FieldArg('field'), FieldArg('field-category')])
            .action(function (classifier, category) {
            return _this.getClassifierName(classifier, category);
        })
            .build());
        return result;
    };
    DynamicFormClassifiersService.prototype.checkIfIdInArray = function (id, idList) {
        for (var _i = 0, idList_1 = idList; _i < idList_1.length; _i++) {
            var toCheck = idList_1[_i];
            if (toCheck === id) {
                return true;
            }
        }
        return false;
    };
    DynamicFormClassifiersService.prototype.resetCache = function () {
        this.classifierNameReplayItems = new Map();
        this.classifierReplayItems = new Map();
    };
    __decorate([
        AsyncDynamicAction('All Records'),
        __param(0, FieldParam('checkedItem|field-category')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Observable)
    ], DynamicFormClassifiersService.prototype, "loadClassifiers", null);
    __decorate([
        AsyncDynamicAction('Currencies with Country', ['reportingcurrencyid',
            'transactioncurrencyid', 'fundingCurrencyId', 'localcurrencyid']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Observable)
    ], DynamicFormClassifiersService.prototype, "loadCountryCurrencies", null);
    __decorate([
        AsyncDynamicAction('Records with parent'),
        __param(0, FieldParam('field-category')),
        __param(1, FieldParam('field-parent')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, ClassifierView]),
        __metadata("design:returntype", Observable)
    ], DynamicFormClassifiersService.prototype, "loadClassifiersByParent", null);
    DynamicFormClassifiersService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ClassifierService,
            CurrentLanguageProvider])
    ], DynamicFormClassifiersService);
    return DynamicFormClassifiersService;
}(AbstractDestructionSubject));
export { DynamicFormClassifiersService };
//# sourceMappingURL=dynamic-form-classifiers.service.js.map